module.exports = "/_next/static/images/icon-d1a67bc2ab2305be3fa78d6a1b0c63ce.png";